import React from 'react';
import { Table, Thead, Tbody, Row, HeadingCell, Cell } from './StyledTable';

export const VibraLimitTable = ({ limits }: { limits: any }) => {
  return (
    <Table>
      <Thead>
        <Row>
          <HeadingCell>Limit</HeadingCell>
          <HeadingCell>X</HeadingCell>
          <HeadingCell>Y</HeadingCell>
          <HeadingCell>Z</HeadingCell>
          <HeadingCell>Total exceedances across all axes</HeadingCell>
          <HeadingCell>Total samples with exceedance</HeadingCell>
        </Row>
      </Thead>
      <Tbody>
        {limits.map((limit, index) => (
          <Row>
            <Cell></Cell>
            <Cell></Cell>
            <Cell></Cell>
            <Cell></Cell>
            <Cell></Cell>
            <Cell></Cell>
          </Row>
        ))}
      </Tbody>
    </Table>
  )
}